var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6679 0.604501C16.4022 0.80601 16.9805 1.39976 17.1768 2.15376C17.5335 3.52031 17.5335 6.37161 17.5335 6.37161C17.5335 6.37161 17.5335 9.22282 17.1768 10.5895C16.9805 11.3435 16.4022 11.9372 15.6679 12.1388C14.3371 12.5049 9.00013 12.5049 9.00013 12.5049C9.00013 12.5049 3.66321 12.5049 2.3323 12.1388C1.59795 11.9372 1.01962 11.3435 0.823354 10.5895C0.466797 9.22282 0.466797 6.37161 0.466797 6.37161C0.466797 6.37161 0.466797 3.52031 0.823354 2.15376C1.01962 1.39976 1.59795 0.80601 2.3323 0.604501C3.66321 0.238281 9.00013 0.238281 9.00013 0.238281C9.00013 0.238281 14.3371 0.238281 15.6679 0.604501ZM7.40015 3.97156V9.30489L11.6668 6.63833L7.40015 3.97156Z",
    fill: "#2F4DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.82874c2c89f1fda1d9c8411e8a3a57d0.svg";
export { ForwardRef as ReactComponent };